import {
	type Control,
	Controller,
	type FieldPath,
	type FieldValues,
} from "react-hook-form";
import {
	FlatRowSwitch,
	type FlatRowSwitchProps,
} from "web_myplann/Shared/Components/FlatRow/FlatRowSwitch";

type Props<
	FormType extends FieldValues,
	TName,
	TContext,
	TTransformed extends FieldValues | undefined,
> = Omit<FlatRowSwitchProps, "checked" | "onChange" | "onBlur"> & {
	control: Control<FormType, TContext, TTransformed>;
	name: TName;
};

export const FlatRowFormSwitch = <
	FormType extends FieldValues,
	TName extends FieldPath<FormType>,
	TContext = unknown,
	TTransformed extends FieldValues | undefined = undefined,
>({
	control,
	name,
	...rest
}: Props<FormType, TName, TContext, TTransformed>) => (
	<Controller
		control={control}
		name={name}
		render={({ field: { value, onChange, onBlur } }) => (
			<FlatRowSwitch
				{...rest}
				checked={!!value}
				onChange={onChange}
				onBlur={onBlur}
			/>
		)}
	/>
);
